<script>
import { language } from './stores.js';
import { isMobile } from './stores.js';
let isItInMobile;
isMobile.subscribe(value => {
		isItInMobile = value;
	});
</script>
<div id="home-body">


<img class:mobiimg="{isItInMobile === true}" src="https://payload.cargocollective.com/1/3/120972/14346409/Fyring_composite_cropped_1000.jpg" alt="---img---">

<!-- src="https://payload.cargocollective.com/1/3/120972/14346409/Fyring_etikett_2022-02-11_531.jpg" alt="---img---"> -->

<div id="text"

class:mobitext="{isItInMobile === true}"
class:nonmobitext="{isItInMobile === false}">
<!-- <img src="https://payload.cargocollective.com/1/3/120972/14346409/Fyring_composite_cropped_1000.jpg" alt="---img---"> -->

{#if $language == 0}

<p>
Kryddbrännvinet Fyring har sitt ursprung i ett 1700-talsrecept,
varsamt tolkat och moderniserat av konstnären och krögaren Stig Fyring (1934-2015).
År 2022 har Stigs familj åter börjat krydda snapsen Fyring och nu
går den att beställa på Systembolaget, samt till maten på klassiska
Stockholmskrogar som Tennstopet och Pelikan.
</p><p>
Fyring är kryddat med bland annat krusmynta, anis, angelica, fänkål, koriander,
citronskal, körsbärskärnor, rosenblad, pomerans och johannesört.
</p><p>

Grönskärs fyr, strax nordost om Sandhamn i Stockholms
skärgård (N59 16,7/E19 01,7) är byggd 1770 och kallas skärgårdens drottning.
Drottningen ledde sjöfarare in till Sandhamnsleden och inloppet till Stockholm
fram till 1964. Innan fyren byggdes fanns här en fyrbåk – en öppen järngryta
med koleld. Då båken krävde en hel del arbete hade den tidens
fyrmanskap fullt sjå med att hålla elden igång.
</p><p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/"> Kolla in snapsen på Systembolaget!
</a>
</p>

<br>
<hr style="width:75%;text-align:center;opacity:50%">
<br>

<em>
<p>
Fyring Kryddbrännvin is a Swedish aquavit or spice brandy
conceived by the artist Stig Fyring (1934-2015), based on a recipe from
the 18th century. In 2022 Fyring Kryddbrännving has been reintroduced
by Stig's children, grand children, and family and it is now available
through Systembolaget and at classic Stockholm venues such as Tennstopet and Pelikan.

</p><p>
The spice mixture is inspired by an old 18th century recipe and the spirits are
produced by Kyrkeby Bränneri, a wonderful distillery which is almost as old, and
makes its spirits from potato, not grain!
</p><p>
The lighthouse on the label is Grönskärs Fyr, located in the Stockholm outer
archipelago and is painted by Stig Fyring in
a watercolour very typical of his swift and charming style.
</p>

<p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/">Take me over to Systembolaget!
</a>
</p>
</em>

{:else if $language == 1}

<p>
Kryddbrännvinet Fyring har sitt ursprung i ett 1700-talsrecept,
varsamt tolkat och moderniserat av konstnären och krögaren Stig Fyring (1934-2015).
År 2022 har Stigs familj åter börjat krydda snapsen Fyring och nu
går den att beställa på Systembolaget, samt till maten på klassiska
Stockholmskrogar som Tennstopet och Pelikan.
</p><p>
Fyring är kryddat med bland annat krusmynta, anis, angelica, fänkål, koriander,
citronskal, körsbärskärnor, rosenblad, pomerans och johannesört.
</p><p>

Grönskärs fyr, strax nordost om Sandhamn i Stockholms
skärgård (N59 16,7/E19 01,7) är byggd 1770 och kallas skärgårdens drottning.
Drottningen ledde sjöfarare in till Sandhamnsleden och inloppet till Stockholm
fram till 1964. Innan fyren byggdes fanns här en fyrbåk – en öppen järngryta
med koleld. Då båken krävde en hel del arbete hade den tidens
fyrmanskap fullt sjå med att hålla elden igång.
</p><p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/"> Kolla in snapsen på Systembolaget!
</a>
</p>





{:else}


<em>
<p>
Fyring Kryddbrännvin is a Swedish aquavit or spice brandy
conceived by the artist Stig Fyring (1934-2015), based on a recipe from
the 18th century. In 2022 Fyring Kryddbrännving has been reintroduced
by Stig's children, grand children, and family and it is now available
through Systembolaget and at classic Stockholm venues such as Tennstopet and Pelikan.

</p><p>
The spice mixture is inspired by an old 18th century recipe and the spirits are
produced by Kyrkeby Bränneri, a wonderful distillery which is almost as old, and
makes its spirits from potato, not grain!
</p><p>
The lighthouse on the label is Grönskärs Fyr, located in the Stockholm outer
archipelago and is painted by Stig Fyring in
a watercolour very typical of his swift and charming style.
</p>

<p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/">Take me over to Systembolaget!
</a>
</p>
</em>



{/if}

</div>
</div>
<style>
	img{
		display: inline-block;
		max-height: 500px;
		border-top:0;
		max-width: 50%;
	}
	#home-body{
		width:100%;
		text-align: center;
	}
	#text{
		display: inline-block;
		margin-left:15px;
		vertical-align:top;
		min-width: 25%;
	}
	.mobitext{
		width: 70%;
		margin-top:21px;
	}
	.nonmobitext{
		width: 25%;
		margin-top:0px;
	}
	.mobiimg{
		width: 70%;
		height:20%;
		margin-top:21px;
	}
	p{
		text-align: left;
		font-size: 13px;
	}
	a{
		text-align: left;
		font-size: 13px;
	}
</style>
